import { AxiosError } from "axios";
import Core from "../core";

async function getInsuranceList(empId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmpInsurance?emp_id=${empId}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getPolicies(companyId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/insurance/getPolicies?companyId=${companyId}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function addInsurance(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v1/insurance/add`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function editInsurance(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v1/insurance/edit`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getExpiredInsurance(empId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getExpiredEmpInsurance?emp_id=${empId}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getInsurers(companyId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getInsurers?companyId=${companyId}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

export const insuranceServices = {
  getInsuranceList,
  getExpiredInsurance,
  addInsurance,
  editInsurance,
  getInsurers,
  getPolicies,
};
